// extracted by mini-css-extract-plugin
export default {"heading":"heading_heading__Xr81l","smSpace":"heading_smSpace__iSt0a"};